import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios'
import VueAxios from 'vue-axios'
import { backendUrl, yandexMetricId } from "./config";
import initYandexMetrika from 'yandex-metrika-vue3'

axios.defaults.baseURL = backendUrl;
const app = createApp(App);
app.use(store)
    .use(router)
    .use(VueAxios, axios)
    .use(initYandexMetrika as any, {
        id: yandexMetricId,
        router: router,
        env: process.env.NODE_ENV
});
app.provide("axios", app.config.globalProperties.axios)
app.mount("#app");